var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { system, layout } from "styled-system";
import { Button } from "./Button";
var svg = system({
    fill: {
        property: "fill",
        scale: "colors",
    },
    stroke: {
        property: "stroke",
        scale: "colors",
    },
});
var svgHover = system({
    hoverFill: {
        property: "fill",
        scale: "colors",
    },
});
export var SvgButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  > svg {\n    &:hover {\n      ", "\n    }\n    ", "\n    ", "\n  }\n"], ["\n  > svg {\n    &:hover {\n      ", "\n    }\n    ", "\n    ", "\n  }\n"])), svgHover, layout, svg);
SvgButton.defaultProps = {
    width: "20px",
    fill: "text",
    hoverFill: "link",
};
var templateObject_1;
//# sourceMappingURL=SvgButton.js.map